import { Component, input, output, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { ActionDto } from '../../kl-grid/grid.models';

@Component({
  selector: 'kl-transaction-toolbar',
  standalone: false,
  templateUrl: './kl-transaction-toolbar.html',
  styleUrl: './kl-transaction-toolbar.scss',
})
export class KlTransactionToolbar {
  readonly doRefresh = input(true);
  readonly filterable = input(false);
  readonly customFilter = input(false);
  readonly doExport = input(true);
  readonly disabledButton = input(false);
  readonly recordFetchLoading = input(false);
  readonly filterMenuModel = input<MenuItem[]>([]);
  readonly otherMenuModel = input<MenuItem[]>([]);
  readonly customToolbar = input<ActionDto[]>([]);
  readonly hasOtherMenu = input(false);
  readonly fullscreenEnabled = input(false);
  readonly fullscreenActive = input(false);
  readonly menuAppendTo = input<unknown>('body');

  readonly refreshClick = output<void>();
  readonly toggleFilterClick = output<void>();
  readonly exportClick = output<string>();
  readonly customToolbarActionClick = output<ActionDto>();
  readonly toggleFullscreenClick = output<void>();

  @ViewChild('filterMenu') filterMenu?: Menu;
  @ViewChild('otherMenu') otherMenu?: Menu;
}
